import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";

const TeamsState = {
  addTeams: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-teams`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    return datas;
  },

  getTeams: async () => {
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-all-teams`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    let datas = response.data;
    return datas;
  },

  updateTeams: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-teams/${id}`,
      requestOptions
    );

    let datas = response.data;
    return datas;
  },

  deleteTeams: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-teams/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    return datas;
  },

  deleteMultiTeams: async (ids) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/delete-multi-teams`,
      ids,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    return datas;
  },
};

export default TeamsState;
